package org.gymly.api

import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js

actual fun createGymlyHttpClient(session: PortalSession): HttpClient = HttpClient(Js) {
    configureGymly(session)
}

actual fun createGymlyImageHttpClient(session: PortalSession): HttpClient = HttpClient(Js) {
    configureGymlyImage(session)
}
